import { z } from 'zod';
import { Cents, Biome } from './common.js';

/** Parcel mirrors the frozen Parcel contract in src/contracts/entities.ts. */
export const Parcel = z.object({
  id: z.string().min(1),
  hectares: z.number().positive(),
  landClass: Biome, // contract: grassland | scrub | woodland | wetland | rocky
  distanceKm: z.number().nonnegative(),
  price: Cents.refine((v) => v > 0, 'parcel price required'),
  owned: z.boolean(),
});

export const Region = z.object({
  id: z.string().regex(/^[a-z][a-z0-9_]*$/),
  name: z.string().min(1),
  description: z.string(),
  starting_region: z.boolean(),
  unlock: z.object({ note: z.string() }).optional(),
  biomes: z.array(Biome).min(1),
  parcels: z.array(Parcel).min(1),
  pricing: z.object({ pricing_note: z.string(), sources: z.array(z.string()) }),
});
export type Region = z.infer<typeof Region>;

export const BiomeDefs = z.object({
  schema_note: z.string(),
  biomes: z.record(Biome, z.object({
    label: z.string().min(1),
    tracking_difficulty: z.number().int().min(1).max(5),
    visibility: z.enum(['low', 'medium', 'high']),
    notes: z.string(),
  })),
});
export type BiomeDefs = z.infer<typeof BiomeDefs>;
